"use strict";

var _from = require("babel-runtime/core-js/array/from");

var _from2 = _interopRequireDefault(_from);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getOwnPropertySymbols = require("babel-runtime/core-js/object/get-own-property-symbols");

var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);

var _iterator = require("babel-runtime/core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("babel-runtime/core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = require("babel-runtime/core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = _setPrototypeOf2.default || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? (0, _create2.default)(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || _assign2.default || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = _promise2.default))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof _symbol2.default === "function" && (g[_iterator2.default] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof _getOwnPropertySymbols2.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols2.default)(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
var next_1 = require("@alicd/next");
var LocaleProvider = require("@alicd/next/lib/locale-provider");
var Row = next_1.Grid.Row,
    Col = next_1.Grid.Col;
var CNAddressLabel_1 = require("./CNAddressLabel");
var util_1 = require("./util");
var Common_1 = require("./Common");
var search_util_1 = require("./search-util");
var lodash_alt_1 = require("./lodash-alt");
// import M from "./CacheUtil"
var TS_START = Date.now();
var KEY_SELECT_VALUE = "KEY_SELECT_VALUE";
// TODO: make it a standard Fusion input component
function selectNodeFromChain(node, chain) {
    var ret = [node];
    return !chain.length ? ret : ret.concat(selectNodeFromChain(node.children.find(function (node) {
        return node.id == chain[0];
    }), chain.slice(1, chain.length)));
}
function anyValueToSelectionId(val) {
    switch (typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) {
        case "string":
        case "number":
            return val.toString();
        case "object":
            return lodash_alt_1.last(util_1.selectionToChain(val));
        default:
            throw "invalid address anyValue " + val;
    }
}
function addressEqual(lhs, rhs) {
    return anyValueToSelectionId(lhs) == anyValueToSelectionId(rhs);
}
function loadAndMergeTownList(params, node, allNodesSet) {
    return __awaiter(this, void 0, void 0, function () {
        var townList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4 /*yield*/, util_1.loadTownData(params, node)];
                case 1:
                    townList = _a.sent();
                    node.children = townList;
                    (0, _assign2.default)(allNodesSet, lodash_alt_1.zipObject(townList.map(function (t) {
                        return t.id;
                    }), townList));
                    return [2 /*return*/, townList];
            }
        });
    });
}
function selectedNodeChain(addressTree, value) {
    var chain = util_1.selectionToChain(value);
    return selectNodeFromChain(addressTree, chain);
}
function getShownTabs(normalizedValue, allNodesSet, maxLevel) {
    var nodeChain = selectedNodeChain(util_1.addressTreeOfSet(allNodesSet), normalizedValue);
    return nodeChain.filter(function (node) {
        return node.children && node.children.length;
    }).slice(1).filter(function (node) {
        return util_1.PANE_ATTRIBUTES[node.children[0].levelKey].index <= maxLevel;
    });
}
var MenuWrap = /** @class */function (_super) {
    __extends(MenuWrap, _super);
    function MenuWrap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerMenu = null;
        return _this;
    }
    // | if we get a Menu => we are searching, mount ref to this.innerMenu
    // | otherwise do nothing just pass down
    MenuWrap.prototype.render = function () {
        var _this = this;
        var ret = React.Children.count(this.props.children) == 1 ? React.cloneElement(React.Children.only(this.props.children), { ref: function ref(n) {
                _this.innerMenu = n;
            } }) : this.props.children;
        return React.createElement("div", __assign({}, this.props), ret);
    };
    // proxy keyDown event for good searching interaction
    MenuWrap.prototype.onKeyNavNodeKeyDown = function () {
        var _a;
        this.innerMenu && this.innerMenu.onKeyNavNodeKeyDown && (_a = this.innerMenu).onKeyNavNodeKeyDown.apply(_a, arguments);
    };
    return MenuWrap;
}(React.Component);
var AddressTextSegment = /** @class */function (_super) {
    __extends(AddressTextSegment, _super);
    function AddressTextSegment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddressTextSegment.prototype.render = function () {
        return React.createElement("span", { style: "display: inline-block;" }, this.props.children);
    };
    return AddressTextSegment;
}(React.Component);
var CNAddress = /** @class */function (_super) {
    __extends(CNAddress, _super);
    function CNAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            addressTree: {},
            countryList: [],
            paneRoot: null,
            uiOverlayVisible: false,
            selectionCommitable: false,
            uiActiveTab: "province",
            uiActiveTabPrev: "province",
            value: {},
            overlayValue: {},
            inSearch: false,
            searchResult: null,
            searchQuery: ""
            // value: props.value || props.defaultValue
        };
        _this.updateHiddenMap(_this.props.hiddenData);
        _this.handleSelect = _this.handleSelect.bind(_this);
        _this.handleSelectCountry = _this.handleSelectCountry.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        _this.handleClear = _this.handleClear.bind(_this);
        _this.handleOverlayVisibleChange = _this.handleOverlayVisibleChange.bind(_this);
        _this.handleActiveTabChanged = _this.handleActiveTabChanged.bind(_this);
        _this.getOverlayContainer = _this.getOverlayContainer.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.handleSearchFocus = _this.handleSearchFocus.bind(_this);
        _this.handleSelectSearchItem = _this.handleSelectSearchItem.bind(_this);
        // TODO: lift address data store into a larger scope
        (function () {
            return __awaiter(_this, void 0, void 0, function () {
                var initialValue, _a, nodeChain, address;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            initialValue = props.value || props.defaultValue;
                            return [4 /*yield*/, this.normalizeValueReturningAddressAndNodeChain(initialValue)
                            // TODO: investigate the sequence problem of valuesetting
                            ];
                        case 1:
                            _a = _b.sent(), nodeChain = _a.nodeChain, address = _a.address;
                            if (!((this.props.value || this.props.defaultValue) == initialValue)) return [3 /*break*/, 3];
                            this.triggerLabelUpdate(nodeChain);
                            return [4 /*yield*/, this.setStateAsync({
                                value: address,
                                searchQuery: this.displayValueFromSelection(address),
                                uiActiveTab: this.getNewActiveTab(address)
                            })];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            if (props.defaultVisible) {
                                this.handleOverlayVisibleChange(true);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        })();
        return _this;
    }
    CNAddress.prototype.updateHiddenMap = function (hiddenList) {
        var ret = lodash_alt_1.zipObject(hiddenList, new Array(hiddenList.length).fill(true));
        this.hiddenMap = ret;
        return ret;
    };
    CNAddress.prototype.getMinSelectLevel = function (props) {
        if (props === void 0) {
            props = this.props;
        }
        var v = props.hasToSelectToLastLevel;
        switch (typeof v === "undefined" ? "undefined" : (0, _typeof3.default)(v)) {
            case "number":
                return v;
            case "boolean":
                return v ? props.level : 0;
            default:
                return 0;
        }
    };
    CNAddress.prototype.selectionLevelCanCommit = function (node, minLevel) {
        return __awaiter(this, void 0, void 0, function () {
            var isCurLevelEnough, curLevelTooSmallButNoAvailableChild, isCurLevelEnough, curLevelNoAvailableChild;
            return __generator(this, function (_a) {
                // these conditions here only "seems" working, in our
                //  very specific circumstances
                //    e.g. every leaf node in the main tree, has some town children,
                //      only area may be omitted in the chain etc.
                // logically they are incorrect
                if (minLevel < 4) {
                    isCurLevelEnough = node.level >= minLevel;
                    curLevelTooSmallButNoAvailableChild = node.isLeaf || node.children.length == 0 || node.children[0].level != node.level + 1;
                    return [2 /*return*/, isCurLevelEnough || curLevelTooSmallButNoAvailableChild];
                } else {
                    isCurLevelEnough = node.level >= minLevel;
                    curLevelNoAvailableChild = node.isLeaf || node.children.length == 0;
                    return [2 /*return*/, isCurLevelEnough || curLevelNoAvailableChild];
                }
                return [2 /*return*/];
            });
        });
    };
    CNAddress.prototype.componentWillReceiveProps = function (nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            var dataset, _a, _b, nextValue, valueNow, _c, normalizedValue, nodeChain;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!("requestAddressUrl" in nextProps && this.props.requestAddressUrl != nextProps.requestAddressUrl)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadAndStoreDataset(this.getRequestParams(nextProps))];
                    case 1:
                        dataset = _d.sent();
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, this.normalizeValue(this.state.value)];
                    case 2:
                        _a.apply(this, [(_b.value = _d.sent(), _b)]);
                        _d.label = 3;
                    case 3:
                        if ("hiddenData" in nextProps && this.props.hiddenData != nextProps.hiddenData) {
                            this.updateHiddenMap(nextProps.hiddenData);
                        }
                        nextValue = function () {
                            if (typeof nextProps.value == "undefined" || nextProps.value === null) {
                                // reseting the field should result in ALL value cleared
                                //  instead of fallback to defaultValue
                                //  but that would not be appropriate for our CNAddress
                                //  (when used without overseas)
                                //  use { } to state an EMPTY value explicitly
                                // return { }
                                return (/*nextProps.defaultValue ||*/_this.props.defaultValue
                                );
                            }
                            return nextProps.value;
                        }();
                        valueNow = this.state.value;
                        return [4 /*yield*/, this.normalizeValueReturningAddressAndNodeChain(nextValue)];
                    case 4:
                        _c = _d.sent(), normalizedValue = _c.address, nodeChain = _c.nodeChain;
                        // TODO: CNAddress + Field + setValue ... need more work on this later
                        if ("value" in nextProps /* && this.state.value == valueNow */) {
                                this.triggerLabelUpdate(nodeChain);
                                if (!addressEqual(nextValue, this.state.value)) {
                                    this.setState({
                                        value: normalizedValue,
                                        searchQuery: this.displayValueFromSelection(normalizedValue),
                                        // 05/12/2017: we need to update activeTab too
                                        //  or the overlay would be empty
                                        // in fact, the active tab may be better implemented
                                        //  as a view constraint, rather than view state
                                        uiActiveTab: this.getNewActiveTab(normalizedValue)
                                    });
                                }
                            }
                        return [2 /*return*/];
                }
            });
        });
    };
    CNAddress.prototype.normalizeValueReturningNodeChain = function (val, params) {
        if (params === void 0) {
            params = this.getRequestParams();
        }
        return __awaiter(this, void 0, void 0, function () {
            var traceTownParentsAndUpdateIfDataNotChanged, dataset, addressTree, allNodesSet, dataset, addressTree, allNodesSet, selectionChain;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        traceTownParentsAndUpdateIfDataNotChanged = function traceTownParentsAndUpdateIfDataNotChanged(town, _a) {
                            var addressTree = _a.addressTree,
                                allNodesSet = _a.allNodesSet;
                            return __awaiter(_this, void 0, void 0, function () {
                                var chain, nodeChain, node, townList;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            return [4 /*yield*/, util_1.traceTownParents(params, town)];
                                        case 1:
                                            chain = _b.sent();
                                            nodeChain = selectNodeFromChain(addressTree, lodash_alt_1.dropRight(1, chain)), node = lodash_alt_1.last(nodeChain);
                                            return [4 /*yield*/, loadAndMergeTownList(params, node, allNodesSet)];
                                        case 2:
                                            townList = _b.sent();
                                            if (this.allNodesSet === allNodesSet) {
                                                this.setState({ addressTree: addressTree });
                                            }
                                            return [2 /*return*/, nodeChain.concat([allNodesSet[town]])];
                                    }
                                });
                            });
                        };
                        if (!(typeof val == "number" || typeof val == "string")) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.dataset(params)];
                    case 1:
                        dataset = _a.sent();
                        addressTree = dataset.addressTree, allNodesSet = dataset.allNodesSet;
                        if (!allNodesSet[val]) return [3 /*break*/, 2];
                        return [2 /*return*/, util_1.nodeChainFromNode(allNodesSet[val])];
                    case 2:
                        return [4 /*yield*/, traceTownParentsAndUpdateIfDataNotChanged(val, dataset)];
                    case 3:
                        return [2 /*return*/, _a.sent()];
                    case 4:
                        return [3 /*break*/, 11];
                    case 5:
                        if (!((typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) == "object")) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.dataset(params)];
                    case 6:
                        dataset = _a.sent();
                        addressTree = dataset.addressTree, allNodesSet = dataset.allNodesSet;
                        if (!(val.town && !this.allNodesSet[val.town])) return [3 /*break*/, 8];
                        return [4 /*yield*/, traceTownParentsAndUpdateIfDataNotChanged(val.town, dataset)];
                    case 7:
                        return [2 /*return*/, _a.sent()];
                    case 8:
                        selectionChain = util_1.selectionToChain(val);
                        if (!selectionChain.length) {
                            return [2 /*return*/, []];
                        }
                        return [2 /*return*/, util_1.nodeChainFromNode(allNodesSet[lodash_alt_1.last(selectionChain)])];
                    case 9:
                        return [3 /*break*/, 11];
                    case 10:
                        throw "CNAddress normalizeValue(): unknown value of " + (typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) + " - " + val;
                    case 11:
                        return [2 /*return*/];
                }
            });
        });
    };
    CNAddress.prototype.normalizeValueReturningAddressAndNodeChain = function (val, params) {
        return __awaiter(this, void 0, void 0, function () {
            var nodeChain, address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.normalizeValueReturningNodeChain(val, params)];
                    case 1:
                        nodeChain = _a.sent();
                        address = util_1.foldNodeChainToSelection(nodeChain);
                        return [2 /*return*/, { nodeChain: nodeChain, address: address }];
                }
            });
        });
    };
    CNAddress.prototype.normalizeValue = function (val, params) {
        return __awaiter(this, void 0, void 0, function () {
            var nodeChain, address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.normalizeValueReturningNodeChain(val, params)];
                    case 1:
                        nodeChain = _a.sent();
                        address = util_1.foldNodeChainToSelection(nodeChain);
                        return [2 /*return*/, address];
                }
            });
        });
    };
    CNAddress.prototype.setStateAsync = function (updater) {
        var _this = this;
        return new _promise2.default(function (resolve, reject) {
            _this.setState(updater, function () {
                return resolve();
            });
        });
    };
    CNAddress.prototype.loadAndStoreDataset = function (params) {
        if (params === void 0) {
            params = this.getRequestParams();
        }
        return __awaiter(this, void 0, void 0, function () {
            var _a, countryList, allNodesSet, addressTree;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        return [4 /*yield*/, util_1.loadAddressData(params)];
                    case 1:
                        _a = _b.sent(), countryList = _a.countryList, allNodesSet = _a.allNodesSet, addressTree = _a.addressTree;
                        this.allNodesSet = allNodesSet;
                        return [4 /*yield*/, this.setStateAsync({
                            countryList: countryList,
                            addressTree: addressTree,
                            paneRoot: allNodesSet["1"]
                        })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, {
                            addressTree: addressTree,
                            allNodesSet: allNodesSet
                        }];
                }
            });
        });
    };
    // TODO: this impl. is not exactly right ...
    CNAddress.prototype.dataset = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.state.paneRoot) return [3 /*break*/, 1];
                        return [2 /*return*/, {
                            addressTree: this.state.addressTree,
                            allNodesSet: this.allNodesSet
                        }];
                    case 1:
                        // concurrency issue ...
                        if (!this._futureDataset) {
                            this._futureDataset = this.loadAndStoreDataset(params);
                        }
                        return [4 /*yield*/, this._futureDataset];
                    case 2:
                        return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CNAddress.prototype.getNewActiveTab = function (newValue) {
        var tabs = getShownTabs(newValue, this.allNodesSet, this.props.level);
        if (tabs.length) {
            return lodash_alt_1.last(tabs).children[0].levelKey;
        } else {
            return "province";
        }
    };
    CNAddress.prototype.handleSelect = function (node, _a) {
        var overlayVisibleOverride = (_a === void 0 ? {} : _a).overlayVisibleOverride;
        return __awaiter(this, void 0, void 0, function () {
            var newNodeChain, newValue, activeTab, stateMutation, _b, townList, nodeChain;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        newNodeChain = util_1.nodeChainFromNode(node);
                        newValue = util_1.foldNodeChainToSelection(newNodeChain);
                        // when the user selected an item in the last level, by common sense,
                        //      his/her work on the pane is done, specifically:
                        //  * if we has selected the value of last level specified in props
                        //  * or we are not in the last level, but we got no child
                        // -> close the pane overlay
                        if (node.levelKey == util_1.PANE_LEVEL_KEYS[this.props.level] || this.props.level < 4 && !node.children.length) {
                            this.setState({ uiOverlayVisible: false });
                        }
                        activeTab = this.getNewActiveTab(newValue);
                        this.setState({ overlayValue: newValue, selectionCommitable: false });
                        stateMutation = { uiActiveTab: activeTab };
                        _b = node.level <= 0;
                        if (_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.selectionLevelCanCommit(node, this.getMinSelectLevel())];
                    case 1:
                        _b = _c.sent();
                        _c.label = 2;
                    case 2:
                        // do not commit if hasToSelectToLastLevel isn't meet
                        //   OR we are clearing (i.e. selecting a country node)
                        //      (you're not able to select a country node in tab panes, except clear)
                        if (_b) {
                            stateMutation.value = newValue;
                            stateMutation.selectionCommitable = true;
                            this.setState(stateMutation);
                            // we do not pass the event down ...
                            this.props.onChange && this.props.onChange(newValue, newNodeChain, newNodeChain);
                        } else {
                            stateMutation.selectionCommitable = false;
                            this.setState(stateMutation);
                        }
                        if (!(this.props.level >= 4 && node.levelKey != "town" && node.levelKey != "country" && !node.children.length)) return [3 /*break*/, 5];
                        return [4 /*yield*/, loadAndMergeTownList(this.getRequestParams(), node, this.allNodesSet)];
                    case 3:
                        townList = _c.sent();
                        return [4 /*yield*/, this.setStateAsync({ addressTree: this.state.addressTree })];
                    case 4:
                        _c.sent();
                        nodeChain = this.selectedNodeChain(this.state.overlayValue);
                        if (this.state.uiOverlayVisible && lodash_alt_1.last(nodeChain) == node) {
                            this.setState({
                                uiActiveTab: townList.length ? "town" : this.state.uiActiveTab,
                                uiOverlayVisible: !!townList.length
                            });
                        }
                        _c.label = 5;
                    case 5:
                        this.exitSearch(newValue);
                        return [2 /*return*/];
                }
            });
        });
    };
    CNAddress.prototype.handleSelectCountry = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var newValue, newNodeChain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newValue = undefined, newNodeChain = [];
                        if (!key) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.normalizeValue({ country: key })];
                    case 1:
                        newValue = _a.sent();
                        newNodeChain = selectNodeFromChain(this.state.addressTree, util_1.selectionToChain(newValue));
                        _a.label = 2;
                    case 2:
                        return [4 /*yield*/, this.setStateAsync({
                            value: newValue || {},
                            uiActiveTab: "province"
                        })];
                    case 3:
                        _a.sent();
                        this.props.onChange && this.props.onChange(newValue || {}, newNodeChain, newNodeChain);
                        return [2 /*return*/];
                }
            });
        });
    };
    // this is invoked only for builtin clear of <Select />
    CNAddress.prototype.handleSelectChange = function (value) {
        if (value === null || value === undefined) {
            this.handleClear();
        }
    };
    CNAddress.prototype.handleClear = function () {
        return __awaiter(this, void 0, void 0, function () {
            var valueOverride, newValue;
            return __generator(this, function (_a) {
                valueOverride = {};
                util_1.PANE_LEVELS.forEach(function (level) {
                    return valueOverride[level] = undefined;
                });
                newValue = __assign({}, this.state.value, valueOverride);
                this.handleSelect(lodash_alt_1.last(selectNodeFromChain(this.state.addressTree, util_1.selectionToChain(newValue))));
                this.exitSearch();
                this.setState({ uiOverlayVisible: false });
                return [2 /*return*/];
            });
        });
    };
    CNAddress.prototype.handleActiveTabChanged = function (key) {
        this.setState({ uiActiveTab: key });
    };
    CNAddress.prototype.handleOverlayVisibleChange = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        arg = { uiOverlayVisible: value };
                        if (!value) return [3 /*break*/, 3];
                        arg.overlayValue = this.state.value;
                        _a = arg;
                        _b = this.selectionLevelCanCommit;
                        _c = lodash_alt_1.last;
                        return [4 /*yield*/, this.normalizeValueReturningNodeChain(this.state.value)];
                    case 1:
                        return [4 /*yield*/, _b.apply(this, [_c.apply(void 0, [_d.sent()]), this.getMinSelectLevel()])];
                    case 2:
                        _a.selectionCommitable = _d.sent();
                        arg.uiActiveTabPrev = this.state.uiActiveTab;
                        this.setState(arg);
                        return [3 /*break*/, 4];
                    case 3:
                        this.exitSearch(this.state.value);
                        if (!this.props.partialSelectionOverlayClosable && !this.state.selectionCommitable) {
                            return [2 /*return*/];
                        }
                        this.setState({ uiOverlayVisible: false });
                        if (!this.state.selectionCommitable) {
                            // we are discarding all selection states
                            //  including UI state
                            arg.uiActiveTab = this.state.uiActiveTabPrev;
                        }
                        this.setState(arg);
                        _d.label = 4;
                    case 4:
                        return [2 /*return*/];
                }
            });
        });
    };
    CNAddress.prototype.exitSearch = function (selection) {
        var searchQuery = selection ? this.displayValueFromSelection(selection) : "";
        this.setState({ inSearch: false, searchQuery: searchQuery, searchResult: null });
    };
    CNAddress.prototype.handleSearch = function (value) {
        value = value.trim();
        this.setState({ searchQuery: value });
        if (!value) {
            this.exitSearch();
            return;
        }
        this.setState({ inSearch: true });
        var queryArgs = {
            ofCountry: this.state.value.country
        };
        var result = search_util_1.doSearch(value, queryArgs, this);
        this.setState({ searchResult: result.length ? result : null });
        this.handleOverlayVisibleChange(true);
    };
    CNAddress.prototype.handleSearchFocus = function (e, clickByUser) {
        if (clickByUser) {
            this.setState({ searchQuery: "" });
            this.handleOverlayVisibleChange(true);
        }
    };
    CNAddress.prototype.handleSelectSearchItem = function (nid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.handleOverlayVisibleChange(false);
                        return [4 /*yield*/, util_1.delay(5)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.handleSelect(this.allNodesSet[nid])];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CNAddress.prototype.selectedNodeChain = function (value) {
        var chain = util_1.selectionToChain(value);
        return selectNodeFromChain(this.state.addressTree, chain);
    };
    CNAddress.prototype.getDisabled = function () {
        return this.props.disabled || this.props.readOnly;
    };
    CNAddress.prototype.safeToRenderForValue = function (value) {
        return !!this.state.paneRoot && (this.props.level < 4 || !value.town || this.allNodesSet[value.town]);
    };
    CNAddress.prototype.safeToRender = function () {
        return this.safeToRenderForValue(this.state.value);
    };
    CNAddress.prototype.getRequestParams = function (props) {
        if (props === void 0) {
            props = this.props;
        }
        return {
            addressURL: props.requestAddressUrl,
            townURL: props.requestTownUrl,
            parentURL: props.requestAddressLevelUrl,
            ignored: props.ignored,
            dataOverride: props.dataOverride,
            preprocessor: props.preprocessor
        };
    };
    CNAddress.prototype.getOverlayContainer = function () {
        var container = this.props.container;
        if (this.props.container) {
            if (typeof container == "function") {
                return container();
            }
            return container;
        }
        return this.refs.outerWrapper;
    };
    CNAddress.prototype.displayValueFromSelection = function (selection) {
        return this.displayValueFromNodeChain(this.selectedNodeChain(selection));
    };
    CNAddress.prototype.displayValueFromNodeChain = function (nodeChain) {
        return nodeChain.slice(2).map(function (node) {
            return node.nameZh;
        }).join(" / ");
        // TODO: is there a better way than this "slice(2)"?
        // return (
        //     <span>
        //         {nodeChain.slice(2)
        //             .map(node => <AddressTextSegment key={node.id}>{node.nameZh}</AddressTextSegment>)}
        //     </span>
        // )
    };
    CNAddress.prototype.triggerLabelUpdate = function (nodeChain) {
        if (typeof this.props.onLabelUpdate == "function") {
            var nodes = nodeChain.filter(function (n) {
                return !!n.parentNode;
            });
            var label = !this.props.overseas && nodes.length <= 1 ? "" : nodes.map(function (n) {
                return n.nameZh;
            }).join(" / ");
            this.props.onLabelUpdate.call(null, label, nodeChain);
        }
    };
    CNAddress.prototype.renderTab = function (pane, node) {
        var _this = this;
        var _a = this.props.language,
            language = _a === void 0 ? 'zh-cn' : _a;
        var renderTag = function renderTag(node) {
            return _this.hiddenMap[node.id] ? null : React.createElement(CNAddressLabel_1.default, { key: node.id, node: node, checked: node.id == _this.state.overlayValue[pane.field], onClick: _this.handleSelect });
        };
        if (this.props.provincePartition == "letter" && node.id === "1") {
            var parts_1 = (0, _from2.default)(Array(Common_1.PROVINCE_LETTERS.length)).map(function () {
                return [];
            });
            node.children.forEach(function (node) {
                return parts_1[Common_1.provinceLetterParititon(node.namePy)].push(node);
            });
            return React.createElement(next_1.Tab.TabPane, { className: "next-cn-address-tabpane", tab: pane.title[language], key: pane.field }, Common_1.PROVINCE_LETTERS.map(function (title, idx) {
                if (!parts_1[idx].length) {
                    return null;
                }
                return React.createElement(Row, { key: idx, type: "no-padding" }, React.createElement(Col, { className: "next-cn-address-provletter", fixedSpan: 2 }, title), React.createElement(Col, null, parts_1[idx].map(renderTag)));
            }));
        }
        return React.createElement(next_1.Tab.TabPane, { tab: pane.title[language], key: pane.field }, React.createElement("div", { className: "next-cn-address-tabpane" }, node.children.map(function (n, index) {
            return _this.hiddenMap[n.id] ? null : React.createElement(CNAddressLabel_1.default, { key: n.id, node: n, checked: n.id == _this.state.overlayValue[pane.field], onClick: _this.handleSelect });
        })));
    };
    CNAddress.prototype.renderTabs = function () {
        var _this = this;
        if (this.safeToRender()) {
            return getShownTabs(this.state.overlayValue, this.allNodesSet, this.props.level).map(function (node) {
                return _this.renderTab(util_1.PANE_ATTRIBUTES[node.children[0].levelKey], node);
            });
        }
    };
    CNAddress.prototype.renderOverlayToolbar = function () {
        if (this.props.hasClear) {
            return React.createElement("div", { className: "next-cn-address-overlay-toolbar", key: "overlayToolbar" }, React.createElement(next_1.Button, { size: "small", onClick: this.handleClear }, "\u6E05\u7A7A"));
        }
        return null;
    };
    CNAddress.prototype.renderOverlayInnerSearch = function () {
        var _this = this;
        return {
            className: "next-cn-address-search-wrap",
            inner: this.state.searchResult ?
            // TODO: this is a horrible hack for 1.x compatibility
            React.createElement(next_1.Menu, { onClick: this.handleSelectSearchItem, onItemClick: this.handleSelectSearchItem }, this.state.searchResult.map(function (nid) {
                return React.createElement(next_1.Menu.Item, { key: nid }, _this.allNodesSet[nid].nameZh);
            })) : React.createElement(next_1.Menu, { ref: "menuInner" }, React.createElement(next_1.Menu.Item, { disabled: true }, "\u65E0\u641C\u7D22\u7ED3\u679C"))
        };
    };
    CNAddress.prototype.renderOverlayInnerTabs = function () {
        return {
            className: {
                "next-cn-address-overlay": true,
                "next-cn-address-fixed-width": this.props.fixedWidth
            },
            inner: [React.createElement(next_1.Tab, { activeKey: this.state.uiActiveTab, onChange: this.handleActiveTabChanged, animation: this.props.animation, key: "overlayTabs" }, this.renderTabs()), this.renderOverlayToolbar()]
        };
    };
    CNAddress.prototype.renderOverlay = function () {
        var _a = this.state.inSearch ? this.renderOverlayInnerSearch() : this.renderOverlayInnerTabs(),
            className = _a.className,
            inner = _a.inner;
        // we have some problems for now:
        //  * Requirement: we want 2 modes for the same overlay:
        //     one for a "standard" search result menu, another for customized address select with tabs;
        //    we also want to utilize arrow keys for search mode (by calling Menu.onKeyNavNodeKeyDown(e))
        //
        //  * <Overlay> breaks if the type of Overlay Root element changed during animation
        //      => means: the elements for the 2 modes must be wrapped in some kind of (stable) root node
        //
        //  * <Overlay> can only pick up ref of the Root element, the children just lost and since we have
        //     to wrap the content, it's difficult to get ref to the wrapped element (to do any operation)
        //
        // solution:
        //  * make a <MenuWrap> element, which always renders to a <div>
        //     (this also helps keep style backward compatible)
        //  * use callback ref to get ref of <Menu> inside <MenuWrap>
        //  * <MenuWrap> will proxy onKeyNavNodeKeyDown(), which will be called by <Select>
        return React.createElement(MenuWrap, { className: classNames(className, this.props.className), ref: "menu" }, inner);
    };
    CNAddress.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            style = _a.style,
            value = _a.value,
            size = _a.size,
            textOnly = _a.textOnly,
            textSerializer = _a.textSerializer,
            level = _a.level,
            addressSelectPlaceholder = _a.addressSelectPlaceholder,
            countrySelectPlaceholder = _a.countrySelectPlaceholder,
            requestAddressUrl = _a.requestAddressUrl,
            requestTownUrl = _a.requestTownUrl,
            requestAddressLevelUrl = _a.requestAddressLevelUrl,
            fixedWidth = _a.fixedWidth,
            overseas = _a.overseas,
            animation = _a.animation,
            hasClear = _a.hasClear,
            container = _a.container,
            ignored = _a.ignored,
            dataOverride = _a.dataOverride,
            preprocessor = _a.preprocessor,
            hiddenData = _a.hiddenData,
            hasToSelectToLastLevel = _a.hasToSelectToLastLevel,
            partialSelectionOverlayClosable = _a.partialSelectionOverlayClosable,
            normalizeInitValue = _a.normalizeInitValue,
            provincePartition = _a.provincePartition,
            showSearch = _a.showSearch,
            onLabelUpdate = _a.onLabelUpdate,
            popupProps = _a.popupProps,
            countryPopupProps = _a.countryPopupProps,
            popupClassName = _a.popupClassName,
            countryPopupClassName = _a.countryPopupClassName,
            _IS_CN_ADDRESS_ = _a._IS_CN_ADDRESS_,
            rest = __rest(_a, ["className", "style", "value", "size", "textOnly", "textSerializer", "level", "addressSelectPlaceholder", "countrySelectPlaceholder", "requestAddressUrl", "requestTownUrl", "requestAddressLevelUrl", "fixedWidth", "overseas", "animation", "hasClear", "container", "ignored", "dataOverride", "preprocessor", "hiddenData", "hasToSelectToLastLevel", "partialSelectionOverlayClosable", "normalizeInitValue", "provincePartition", "showSearch", "onLabelUpdate", "popupProps", "countryPopupProps", "popupClassName", "countryPopupClassName", "_IS_CN_ADDRESS_"]);
        var elements = [];
        // if we are loading address data -> show a "loading" status
        // if the user has enabled "overseas" -> show a country select
        // if the current country has more fine-grained address data,
        //      and the user does not forbid it explicitly -> show address select pane
        //  (just a fancy FizzBuzz ...
        if (!this.safeToRender()) {
            elements.push(React.createElement("span", { key: "dataLoading", className: classNames("next-cn-address-loading", className), style: style }, rest.locale.loading));
        } else {
            var nodeChain = this.selectedNodeChain(this.state.value);
            if (this.props.textOnly) {
                var text = "";
                if (nodeChain.length < 2) {
                    text = textSerializer([]);
                } else {
                    text = textSerializer(nodeChain.slice(1));
                }
                return React.createElement("span", __assign({ className: classNames("next-cn-address-text", className), style: style }, rest), text);
            }
            if (overseas) {
                elements.push(React.createElement(next_1.Select, { key: "countrySelect", className: "next-cn-address-country", value: this.state.value.country, size: size, placeholder: countrySelectPlaceholder || rest.locale.countrySelectPlaceholder, dataSource: this.state.countryList, onChange: this.handleSelectCountry,
                    // great that Next <Search /> has already implemented a default onSearch()
                    showSearch: true, disabled: this.getDisabled(), hasClear: hasClear, container: this.getOverlayContainer, popupProps: countryPopupProps, popupClassName: countryPopupClassName }));
            }
            var countryHasChild = nodeChain.length >= 2 && nodeChain[1].children && nodeChain[1].children.length;
            // TODO: customize domestic select visibility on disabled
            if (countryHasChild && this.props.level >= 1 && (this.getDisabled() && nodeChain.length > 2 || !this.getDisabled() || !this.props.overseas)) {
                var props = {
                    key: "domesticSelect",
                    className: "next-cn-address-domestic",
                    size: size,
                    placeholder: addressSelectPlaceholder || rest.locale.addressSelectPlaceholder,
                    overlay: this.renderOverlay(),
                    visible: this.state.uiOverlayVisible,
                    onVisibleChange: this.handleOverlayVisibleChange,
                    disabled: this.getDisabled(),
                    onChange: this.handleSelectChange,
                    hasClear: hasClear,
                    container: this.getOverlayContainer,
                    hasArrow: true,
                    popupProps: popupProps,
                    popupClassName: popupClassName
                };
                var displayValue = this.state.uiOverlayVisible ? this.displayValueFromSelection(this.state.overlayValue) : this.displayValueFromNodeChain(nodeChain);
                var label = !showSearch ? displayValue : this.state.searchQuery;
                var searchValue = { label: label, value: KEY_SELECT_VALUE };
                if (!label) {
                    searchValue = undefined;
                }
                props.dataSource = searchValue ? [searchValue] : [];
                props.value = searchValue && KEY_SELECT_VALUE;
                if (showSearch) {
                    props.value = searchValue && searchValue.label || "";
                    props.onInputUpdate = this.handleSearch;
                    props.onInputFocus = this.handleSearchFocus;
                }
                var SelectComp = showSearch ? next_1.Select.Combobox : next_1.Select;
                elements.push(React.createElement(SelectComp, __assign({}, props)));
            }
        }
        // if (elements.length == 1) {
        //     const element = elements[0];
        //     return React.cloneElement(element, {
        //         className: classNames(element.props.className, "next-cn-address", className),
        //         style: Object.assign({ }, element.props.style, style)
        //     });
        // } else {
        return React.createElement("span", { className: classNames("next-cn-address", className), style: style,
            // { ... rest }
            ref: "outerWrapper" }, elements);
        // }
    };
    CNAddress.propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        value: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),
        defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),
        onChange: PropTypes.func,
        size: PropTypes.oneOf(["small", "medium", "large"]),
        overseas: PropTypes.bool,
        level: PropTypes.number,
        addressSelectPlaceholder: PropTypes.string,
        countrySelectPlaceholder: PropTypes.string,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        // TODO: can do better - componentSerializer
        textOnly: PropTypes.bool,
        textSerializer: PropTypes.func,
        requestAddressUrl: PropTypes.string,
        requestTownUrl: PropTypes.string,
        requestAddressLevelUrl: PropTypes.string,
        fixedWidth: PropTypes.bool,
        animation: PropTypes.bool,
        hasClear: PropTypes.bool,
        container: PropTypes.func,
        ignored: PropTypes.arrayOf(PropTypes.string),
        dataOverride: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
        preprocessor: PropTypes.func,
        hiddenData: PropTypes.arrayOf(PropTypes.string),
        hasToSelectToLastLevel: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        partialSelectionOverlayClosable: PropTypes.bool,
        normalizeInitValue: PropTypes.bool,
        provincePartition: PropTypes.oneOf(["letter"]),
        showSearch: PropTypes.bool,
        onLabelUpdate: PropTypes.func,
        popupProps: PropTypes.object,
        popupClassName: PropTypes.string,
        countryPopupProps: PropTypes.object,
        countryPopupClassName: PropTypes.string,
        _IS_CN_ADDRESS_: PropTypes.bool,
        defaultVisible: PropTypes.bool
    };
    CNAddress.defaultProps = {
        defaultValue: {
            country: "1",
            province: undefined,
            city: undefined,
            area: undefined,
            town: undefined
        },
        level: 4,
        disabled: false,
        readOnly: false,
        textOnly: false,
        textSerializer: util_1.defaultTextSerializer,
        requestAddressUrl: "//division-data.alicdn.com/simple/addr_4_1111_1_0.js",
        requestTownUrl: "//lsp.wuliu.taobao.com/locationservice/addr/output_address_town.do",
        requestAddressLevelUrl: "//lsp.wuliu.taobao.com/locationservice/addr/outputParentDivisons.do",
        fixedWidth: true,
        animation: true,
        hasClear: false,
        container: null,
        ignored: [],
        dataOverride: {},
        preprocessor: util_1.id,
        hiddenData: [],
        hasToSelectToLastLevel: false,
        partialSelectionOverlayClosable: true,
        normalizeInitValue: false,
        showSearch: false,
        _IS_CN_ADDRESS_: true,
        defaultVisible: false
    };
    return CNAddress;
}(React.Component);
var CNAddressWithLocal = LocaleProvider(CNAddress);
CNAddressWithLocal.LOCALE = {
    'zh-cn': {
        loading: '加载数据中...',
        countrySelectPlaceholder: '请选择国家',
        addressSelectPlaceholder: '请选择地址'
    },
    'zh-tw': {
        loading: '加載數據中...',
        countrySelectPlaceholder: '請選擇國家',
        addressSelectPlaceholder: '請選擇地址'
    },
    'en-us': {
        loading: 'loading data...',
        countrySelectPlaceholder: 'please select a country',
        addressSelectPlaceholder: 'please select an address'
    }
};
exports.default = CNAddressWithLocal;
//# sourceMappingURL=CNAddress.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/CNAddress.js
// module id = 519
// module chunks = 0